export default __webpack_public_path__ + "static/media/Settings.20a569dd.svg";